import { getLabel } from '@apia/util';
import { TFormsAssistantConfigurations } from './types';
import { canDocument } from './canDocument';

export const getFormsAssistantConfiguration =
  (): TFormsAssistantConfigurations => {
    const formsAssistantConfigurations: TFormsAssistantConfigurations = {
      OBSERVATIONS: {
        label: getLabel('sbtEjeObs').text.toUpperCase(),
        name: 'OBSERVATIONS',
      },
      ALLOW_MODIFY_AUTOCOMPLETE: {
        label: getLabel('lblAiAllowModifyAutoComplete').text.toUpperCase(),
        name: 'ALLOW_MODIFY_AUTOCOMPLETE',
      },
      ...(canDocument()
        ? {
            FORCE_DOCUMENT_PROCESS_FLOW: {
              label: getLabel(
                'lblAiAvoidDocumentProcessFlow',
              ).text.toUpperCase(),
              name: 'FORCE_DOCUMENT_PROCESS_FLOW',
            },
          }
        : {}),
    };
    return formsAssistantConfigurations;
  };
